import { CoordinatesLayer } from '@App/app/entities/layer/coordinates-layer.model';
import { Component } from '@angular/core';
import { BaseLayerPropertiesComponent } from '../base-layer-properties/base-layer-properties.component';

@Component({
  selector: 'app-coordinate-properties',
  templateUrl: './coordinate-properties.component.html',
})
export class CoordinatePropertiesComponent extends BaseLayerPropertiesComponent<CoordinatesLayer> {}
